export const getAppliedPromoIdsFromCartReviewsItems = cartReviewsItems => {
  const appliedPromoIds = cartReviewsItems
    ?.map(item => item?.itemCosts?.promotionDiscounts?.[0]?.id)
    ?.filter(promoId => promoId !== undefined);
  const appliedUniquePromoIds = [...new Set(appliedPromoIds)];

  return appliedUniquePromoIds;
};

export const getCartReviewsItemsFromPayload = payload => {
  // if storedOfferingTypes exists, then we are calling getfulfillmentofferingsandcartreviews/v7
  // if storedOfferingTypes doesn't exist, then we are calling getfulfillmenttypesofferingsandcartreviews/v3
  // pull cart reviews items from a different location depending on the endpoint
  const cartReviewsItems = payload?.storedOfferingTypes
    ? payload?.fulfillmentOfferings?.cartReviews?.response?.fulfillmentGroups?.[0]?.items
    : payload?.availableFulfillmentTypes?.fulfillmentOfferings?.cartReviews?.response
        ?.fulfillmentGroups[0]?.items;

  return cartReviewsItems;
};
